import find from 'lodash/find'
import store from '../../store'
import { formatSubjectToString } from '../formatSubjectToString'
import { formatGradesForAnalytics } from './formatGradesForAnalytics'
import analytics from '../cdpAnalytics'

export function sendPublishRepoEvent(repoId) {
  const state = store.getState()
  const repo = find(state.repos, { id: repoId })
  const { service } = state

  if (repo) {
    const repoName = repo.name
    const repoDescription = repo.description
    let isPro = false
    if (service.product === 'plus') {
      isPro = true
    }
    const formattedSubject = formatSubjectToString(repo.subject)

    const analyticsInfo = formatGradesForAnalytics(repo.grade)

    analytics.track('Published Repo', {
      ...analyticsInfo,
      repoId,
      name: repoName,
      subject: formattedSubject,
      language: repo.language,
      gradeArray: repo.grade,
      authorUsername: repo.author.username,
      description: repoDescription,
      authorIsPro: isPro,

    })
  }
}
